<template>
    <div class="row">
        <div class="col-lg-12">
            <card shadow>
                <div class="card-body">
                    <form @submit.prevent="validateFormFisrt">
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label>
                                        <span class="text-danger">*</span> Messaging API Channel ID
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ตัวอย่าง  99999xxxxx"
                                        :class="{ 'is-invalid': submitFormFirst && $v.formFirst.messagingChannelId.$error }"
                                        v-model="formFirst.messagingChannelId"
                                    />
                                    <label
                                        v-if="submitFormFirst && !$v.formFirst.messagingChannelId.required"
                                        class="invalid-feedback"
                                    >กรุณากรอก Messaging API Channel ID</label>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label>
                                        <span class="text-danger">*</span> Messaging API Channel Secret
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ตัวอย่าง  99999xxxxx"
                                        :class="{ 'is-invalid': submitFormFirst && $v.formFirst.messagingChannelSecret.$error }"
                                        v-model="formFirst.messagingChannelSecret"
                                    />
                                    <label
                                        v-if="submitFormFirst && !$v.formFirst.messagingChannelSecret.required"
                                        class="invalid-feedback"
                                    >กรุณากรอก Messaging API Channel Secret</label>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>
                                        Webhook URL
                                    </label>
                                    <b-input-group>
                                        <b-form-input 
                                            ref="linkWebhook" 
                                            disabled
                                            v-model="formFirst.webhookUrl"
                                        ></b-form-input>
                                        <b-input-group-append @click="copyText(formFirst.webhookUrl)">
                                            <b-input-group-text class="cursor-pointer">
                                                <i class="far fa-copy"></i>
                                            </b-input-group-text>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group">
                                    <label>
                                        <span class="text-danger">*</span> Messaging API Channel Access Token
                                    </label>
                                    <input
                                        type="text"
                                        class="form-control"
                                        placeholder="ตัวอย่าง  tyixuPKp4RLLBPWqW+AufDUPy3eZ5iszS4Ca9nQua6l8LnCTgmknRMTk86W94vhLj7VlCs+zwVf"
                                        :class="{ 'is-invalid': submitFormFirst && $v.formFirst.messagingChannelAccessToken.$error }"
                                        v-model="formFirst.messagingChannelAccessToken"
                                    />
                                    <label
                                        v-if="submitFormFirst && !$v.formFirst.messagingChannelAccessToken.required"
                                        class="invalid-feedback"
                                    >กรุณากรอก Messaging API Channel Access Token</label>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12 d-flex justify-content-end">
                                <b-button variant="primary" type="submit">
                                    <i class="fas fa-circle-notch fa-spin" v-if="formFirst.isLoading"></i> เชื่อมต่อ Messaging API
                                </b-button>
                            </div>
                        </div>
                    </form>
                </div>
            </card>
        </div>
    </div>
</template>

<script>
import {
  required
} from "vuelidate/lib/validators";
import { STEP_FIRST, copyText } from '@/plugins/index'

export default {
    props:{
        formFirst:{
            type: Object,
            default: () => {}
        }
    },
    data: () => ({
        copyText,
        submitFormFirst: false
    }),
    validations() {
        return {
            formFirst: {
                messagingChannelId: { required },
                messagingChannelSecret: { required },
                messagingChannelAccessToken: { required }
            }
        };
    },
    methods:{
        validateFormFisrt(){
            this.submitFormFirst = true;
            this.$v.formFirst.$touch();
            if ( this.$v.formFirst.$invalid ) {
                return false
            }
            this.submitFormFirst = false;

            this.$emit( 'submitForm' , STEP_FIRST )
        }
    }
}
</script>